import type {PinRegion} from '../../types';

import {cn} from '@ds/helpers';

type RegionSelectorProps = {
  regions: PinRegion[];
  selectedRegion?: PinRegion;
  onSelect: (region: PinRegion) => void;
};

const RegionSelector: React.FC<RegionSelectorProps> = ({regions, selectedRegion, onSelect}) => {
  return (
    <div className="absolute inset-x-0 top-0 z-10 flex overflow-x-auto border-b border-gray-03 bg-white">
      {regions.map((region) => {
        const isSelected = selectedRegion?.polygon_id === region.polygon_id;

        return (
          <button
            type="button"
            key={region.polygon_id}
            className={cn(
              'min-w-37.5 flex-1 cursor-pointer border-b-3 border-transparent p-2.5 text-body-sm text-gray-05 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-orange',
              isSelected && 'border-neutral-fg text-neutral-fg'
            )}
            aria-pressed={isSelected}
            onClick={() => onSelect(region)}
          >
            {region.region_name}
          </button>
        );
      })}
    </div>
  );
};

export default RegionSelector;
